import { render } from "./postsMsg.vue?vue&type=template&id=405b4a2a&scoped=true"
import script from "./postsMsg.vue?vue&type=script&lang=js"
export * from "./postsMsg.vue?vue&type=script&lang=js"

import "../css/antd.css?vue&type=style&index=0&lang=css"
import "./postsMsg.vue?vue&type=style&index=1&id=405b4a2a&lang=scss"
import "./postsMsg.vue?vue&type=style&index=2&id=405b4a2a&scoped=true&lang=scss"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-405b4a2a"]])

export default __exports__